import { render } from "./Cookies.vue?vue&type=template&id=1f4145e2"
import script from "./Cookies.vue?vue&type=script&lang=js"
export * from "./Cookies.vue?vue&type=script&lang=js"
script.render = render

export default script